import PropTypes from 'prop-types';
import { components } from 'react-select';
import { ArrowUpward, ArrowDownward } from '@material-ui/icons';
import Icon from '@ui/components/Icon/Icon';
import WithOptionalTooltip from '../WithOptionalTooltip/WithOptionalTooltip';

const COLORS = {
	PRIMARY: '#1976d2',
	DEFAULT: '#333'
};

const isDirectionSelected = ( data, ascending ) => data.isDirection && (
	( data.id === 'ascending' && ascending )
	|| ( data.id === 'descending' && !ascending )
);

const getDirectionIcon = ( direction, className ) => ( direction === 'ascending'
	? <ArrowUpward className={className} />
	: <ArrowDownward className={className} /> );

const SortSelectorDirectionOption = ( { data, ascending, onDirectionHover, ...restProps } ) => {
	const isSelected = isDirectionSelected( data, ascending );

	const handleMouseEnter = () => {
		if ( onDirectionHover ) {
			onDirectionHover( data.id );
		}
	};

	const handleMouseLeave = () => {
		if ( onDirectionHover ) {
			onDirectionHover( null );
		}
	};

	return (
		<div
			className="option-wrapper"
			onMouseEnter={handleMouseEnter}
			onMouseLeave={handleMouseLeave}
		>
			<components.Option {...restProps}>
				<div className="arrow-icon-container">
					{getDirectionIcon( data.id, `arrow-icon ${isSelected ? 'selected' : ''}` )}
				</div>
				<p className={`name option-name with-arrow ${isSelected ? 'selected' : ''}`}>
					{data.label}
				</p>
				{isSelected && <Icon icon="check" size="20" color={COLORS.PRIMARY} />}
			</components.Option>
		</div>
	);
};

const SortSelectorOption = ( {
	data, onDirectionHover, ascending, ...restProps
} ) => {
	if ( data.isSeparator ) {
		return <div className="option-separator" />;
	}

	if ( data.isDirection ) {
		return (
			<SortSelectorDirectionOption
				{...restProps}
				data={data}
				ascending={ascending}
				onDirectionHover={onDirectionHover}
			/>
		);
	}

	return (
		<div className="option-wrapper">
			<WithOptionalTooltip tooltip={data.tooltip}>
				<components.Option {...restProps}>
					<p className={`name option-name ${restProps.isSelected ? 'selected' : ''}`}>
						{data.label}
					</p>
					{restProps.isSelected && <Icon icon="check" size="20" color={COLORS.PRIMARY} />}
				</components.Option>
			</WithOptionalTooltip>
		</div>
	);
};

SortSelectorDirectionOption.propTypes = {
	data: PropTypes.shape( {
		id: PropTypes.string,
		label: PropTypes.string
	} ),
	ascending: PropTypes.bool,
	onDirectionHover: PropTypes.func
};

SortSelectorOption.propTypes = {
	data: PropTypes.shape( {
		id: PropTypes.string,
		label: PropTypes.string,
		tooltip: PropTypes.string,
		isDirection: PropTypes.bool,
		isSeparator: PropTypes.bool
	} ),
	onDirectionHover: PropTypes.func,
	ascending: PropTypes.bool,
	selected: PropTypes.shape( {
		id: PropTypes.string
	} )
};

export default SortSelectorOption;
export { SortSelectorDirectionOption };
